"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lock2 = void 0;
var _react = _interopRequireDefault(require("react"));
var _SVG = require("../SVG");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Lock2 = _ref => {
  let {
    color = "#13126C",
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_SVG.SVG, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M9.127 4.065a4.063 4.063 0 0 1 6.935 2.872v3.051H7.938v-3.05c0-1.078.429-2.111 1.19-2.873Zm8.935 2.872v3.051h1.025a3.025 3.025 0 0 1 3.025 3.025c0 .699-.283 3.161-1.659 5.485-1.415 2.391-3.994 4.628-8.454 4.628-4.46 0-7.04-2.237-8.454-4.628-1.375-2.324-1.658-4.786-1.658-5.485a3.025 3.025 0 0 1 3.025-3.025h1.026v-3.05a6.063 6.063 0 0 1 12.125 0ZM3.887 13.014c0-.566.459-1.025 1.025-1.025h14.175c.566 0 1.025.46 1.025 1.025 0 .42-.224 2.514-1.38 4.467-1.116 1.886-3.092 3.646-6.733 3.646-3.64 0-5.617-1.76-6.733-3.646-1.156-1.953-1.38-4.047-1.38-4.467Zm6.922 1.84c.231-.638.927-.977 1.57-.764a1.253 1.253 0 0 1 .114 2.355v1.56a.482.482 0 0 1-.965 0v-1.56a1.253 1.253 0 0 1-.719-1.592Z",
    clipRule: "evenodd"
  }));
};
exports.Lock2 = Lock2;
Lock2.displayName = "Lock2";